import { render, staticRenderFns } from "./app-info-block.vue?vue&type=template&id=0433c9ff&"
import script from "./app-info-block.vue?vue&type=script&lang=js&"
export * from "./app-info-block.vue?vue&type=script&lang=js&"
import style0 from "./app-info-block.vue?vue&type=style&index=0&id=0433c9ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports